// Argon Dashboard 2 MUI layouts
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Courses from "layouts/courses";
import CreateCourse from "layouts/course";
import CourseDetail from "layouts/courses/CourseDetail";
import MyEnrollments from "layouts/courses/MyEnrollments";
import CourseBuilder from "layouts/courses/CourseBuilder";
import CoursePlayer from "layouts/courses/CoursePlayer";
import CourseLibrary from "layouts/courses/CourseLibrary";
import ExploreCourses from "layouts/courses/ExploreCourses";
import Creators from "layouts/creators";
import AssessmentBuilder from "layouts/assessments/AssessmentBuilder";
import Certificates from "layouts/certificates";
import Payments from "layouts/payments";
import SupportTickets from "layouts/support";
import CourseModule from "layouts/course/courseModule";
import AssessmentsList from "layouts/course/AssessmentsList";
// Argon Dashboard 2 MUI components
import Box from "themeComponents/Box";
import NotFoundPage from "layouts/notFound";
import { appLogo } from "configs/constants";
import { resolveCompCheckAppUrl } from "configs/serviceUrls";
import { ReactElement } from "react";
interface Route {
  type: "route" | "title" | "divider";
  name?: string;
  key: string;
  route?: string;
  auth?: boolean | null;
  icon?: ReactElement;
  component?: ReactElement;
  hideFromSidebar?: boolean;
  title?: string;
  collapse?: Route[];
  href?: string;
}

const routes: Route[] = [
  {
    type: "route",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    auth: false,
    icon: <Box component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Dashboard />,
  },
  {
    type: "title",
    title: "Learning",
    key: "learning",
  },
  {
    type: "route",
    name: "Courses",
    key: "courses",
    route: "/courses",
    auth: false,
    icon: <Box component="i" color="info" fontSize="14px" className="ni ni-book-bookmark" />,
    component: <Courses />,
  },
  {
    type: "route",
    name: "Explore Courses",
    key: "explore-courses",
    route: "/courses/explore",
    auth: false,
    icon: <Box component="i" color="warning" fontSize="14px" className="ni ni-world" />,
    component: <ExploreCourses />,
  },
    {
      type: "route",
      name: "My Enrollments",
      key: "my-enrollments",
      route: "/courses/my-enrollments",
      auth: false,
      icon: <Box component="i" color="success" fontSize="14px" className="ni ni-hat-3" />,
      component: <MyEnrollments />,
    },
    {
      type: "route",
      name: "My Library",
      key: "course-library",
      route: "/courses/library",
      auth: false,
      icon: <Box component="i" color="info" fontSize="14px" className="ni ni-book-bookmark" />,
      component: <CourseLibrary />,
    },
  // {
  //   type: "route",
  //   name: "Assessments",
  //   key: "assessments",
  //   route: "/assessments",
  //   auth: false,
  //   icon: <Box component="i" color="warning" fontSize="14px" className="ni ni-paper-diploma" />,
  //   component: <Assessments />,
  // },
  {
    type: "route",
    name: "Assessments List",
    key: "assessments-list",
    auth: false,
    route: "/courses/:courseId/assessments/list",
    component: <AssessmentsList />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Add Assessment",
    key: "add-assessment",
    auth: false,
    route: "/courses/:courseId/assessments/add",
    component: <AssessmentBuilder />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Certificates",
    key: "certificates",
    route: "/certificates",
    auth: false,
    icon: <Box component="i" color="success" fontSize="14px" className="ni ni-trophy" />,
    component: <Certificates />,
  },
  {
    type: "title",
    title: "Management",
    key: "management",
  },
  {
    type: "route",
    name: "Payments",
    key: "payments",
    route: "/payments",
    auth: false,
    icon: <Box component="i" color="info" fontSize="14px" className="ni ni-money-coins" />,
    component: <Payments />,
  },
  {
    type: "route",
    name: "Tickets",
    key: "tickets",
    route: "/tickets",
    auth: false,
    icon: <Box component="i" color="primary" fontSize="14px" className="ni ni-chat-round" />,
    component: <SupportTickets />,
  },
  {
    type: "route",
    name: "Creators",
    key: "creators",
    route: "/creators",
    auth: false,
    icon: <Box component="i" color="warning" fontSize="14px" className="ni ni-badge" />,
    component: <Creators />,
  },
  {
    type: "route",
    name: "CompCheck",
    key: "compcheck",
    href: resolveCompCheckAppUrl(),
    auth: false,
    icon: (
      <Box
        component="img"
        src={appLogo}
        alt="CompCheck"
        sx={{ width: 22, height: 22, objectFit: "contain", display: "block" }}
      />
    ),
  },
  { type: "title", title: "Account Pages", key: "account-pages" },
  {
    type: "route",
    name: "Profile",
    key: "profile",
    route: "/profile",
    auth: false,
    icon: <Box component="i" color="dark" fontSize="14px" className="ni ni-single-02" />,
    component: <Profile />,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    auth: true,
    route: "/authentication/sign-in",
    icon: (
      <Box component="i" color="warning" fontSize="14px" className="ni ni-single-copy-04" />
    ),
    component: <SignIn />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    auth: true,
    route: "/authentication/sign-up",
    icon: <Box component="i" color="info" sx={{ fontSize: "14px" }} className="ni ni-collection" />,
    component: <SignUp />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Create Course",
    key: "create-course",
    auth: false,
    route: "/courses/create",
    component: <CreateCourse />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Create Module",
    key: "create-module",
    auth: false,
    route: "/courses/:courseId/modules",
    component: <CourseModule />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Course Builder",
    key: "course-builder",
    auth: false,
    route: "/courses/:id/builder",
    component: <CourseBuilder />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Course Player",
    key: "course-player",
    auth: false,
    route: "/courses/:id/play",
    component: <CoursePlayer />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Assessment Builder",
    key: "assessment-builder",
    auth: false,
    route: "/courses/:courseId/assessments/:assessmentID?",
    component: <AssessmentBuilder />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Edit Course",
    key: "edit-course",
    auth: false,
    route: "/courses/:id/edit",
    component: <CreateCourse />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Course Detail",
    key: "course-detail",
    auth: false,
    route: "/courses/:id",
    component: <CourseDetail />,
    hideFromSidebar: true,
  },
  {
    type: "route",
    name: "Not Found",
    key: "not-found",
    auth: null,
    route: "/not-found",
    icon: <Box component="i" color="info" sx={{ fontSize: "14px" }} className="ni ni-collection" />,
    component: <NotFoundPage />,
    hideFromSidebar: true,
  },
];

export default routes;
